var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['divider-container', _vm.currentStyle],style:(_vm.cssVars)},[_c('div',{staticClass:"divider-line"})])}
var staticRenderFns = []

export { render, staticRenderFns }